import React from "react";
import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export default function BestSolutionsSkeleton() {
    return <Skeleton height={2589} />;
}
